import { render } from "./AgreementDetails.vue?vue&type=template&id=49da70ea&scoped=true"
import script from "./AgreementDetails.vue?vue&type=script&lang=js"
export * from "./AgreementDetails.vue?vue&type=script&lang=js"

import "./AgreementDetails.vue?vue&type=style&index=0&id=49da70ea&lang=css"
import "./AgreementDetails.vue?vue&type=style&index=1&id=49da70ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49da70ea"]])

export default __exports__